import { Organization } from '../../organizations/types/organization.type';

export function resolveDefaultOwnerId(ownerId: string, organization: Organization): string {
  const validIds = [organization.contact.id, ...organization.members.map((member) => member.id)];
  return validIds.includes(ownerId) ? ownerId : organization.contact.id;
}
